import { CalendarCheck2, MessageCircle } from "lucide-react";
import { CONTACT } from "@/data/siteData";
import { HOME } from "@/constants/testIds";
import { trackBookingClick, trackWhatsappClick } from "@/lib/analytics";

export default function FinalCTA() {
  const wa = `https://wa.me/39${CONTACT.whatsapp}`;
  return (
    <section className="relative bg-[#0B4A5A] text-white overflow-hidden">
      <div className="absolute inset-0 opacity-[0.06]">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage:
              "radial-gradient(circle at 20% 30%, rgba(198,168,107,0.6), transparent 40%), radial-gradient(circle at 80% 70%, rgba(198,168,107,0.4), transparent 50%)",
          }}
        />
      </div>
      <div className="gold-line absolute top-0 left-0 right-0" />
      <div className="relative max-w-5xl mx-auto px-6 md:px-10 py-24 md:py-32 text-center">
        <p className="text-[11px] uppercase tracking-[0.24em] text-[#C6A86B]">
          Prenota ora
        </p>
        <h2 className="font-serif text-4xl md:text-6xl mt-5 leading-[1.05] max-w-3xl mx-auto">
          Hai sintomi digestivi?
        </h2>
        <p className="mt-6 text-white/80 text-lg max-w-xl mx-auto leading-relaxed">
          Prenota una visita specialistica. Un percorso chiaro e personalizzato
          per ritrovare il benessere.
        </p>

        <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            data-testid={HOME.ctaFinalBook}
            href={CONTACT.miodottore}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackBookingClick("final_cta")}
            className="inline-flex items-center gap-2 bg-white text-[#0B4A5A] px-9 py-5 rounded-full text-base font-medium hover:bg-[#F9FAFB] transition-all duration-300 hover:-translate-y-1 shadow-[0_10px_30px_rgba(198,168,107,0.25)]"
          >
            <CalendarCheck2 size={18} strokeWidth={1.6} />
            Prenota una visita
          </a>
          <a
            href={wa}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackWhatsappClick("final_cta")}
            className="inline-flex items-center gap-2 border border-white/30 px-9 py-5 rounded-full text-base font-medium hover:border-[#C6A86B] hover:text-[#C6A86B] transition-all duration-300"
          >
            <MessageCircle size={18} strokeWidth={1.6} />
            Scrivi su WhatsApp
          </a>
        </div>
      </div>
      <div className="gold-line absolute bottom-0 left-0 right-0" />
    </section>
  );
}
